module.exports = __webpack_public_path__ + "static/media/history-bagpipe.54ba9a8a.vtt";